import { BasePortalService } from './BasePortalService';

export default class CartService extends BasePortalService {
    constructor() {
        super();
        this.updateQuantityEndpoint = '/cart/updatequantity';
        this.addItemEndpoint = '/cart/addtocart';
        this.sharedCartEmailEndpoint = '/cart/sendsharedcartemail',
        this.sharedCartUrlEndpoint = '/cart/sharedcarturl'
    }

    updateCart(params) {
        return this.patch(this.updateQuantityEndpoint, params);
    }

    async addToCart(params) {
        const response = await this.post(this.addItemEndpoint, params);

        return response;
    }

    async getSharedCartUrl() {
        const response = await this.get(this.sharedCartUrlEndpoint);
        return response;
    }

    async sendSharedCartEmail(params) {
        const response = await this.post(this.sharedCartEmailEndpoint, params);
        return response;
    }
}